export default "__VITE_ASSET__3a4b4c22__"